import web from "../web";

class ClassesoptionsService {
    
    index(token){
        return web.get("/api/classesoptions", { headers: { 'Authorization': 'Bearer '+token } })
    }
    store(data, token){
        return web.post("/api/classesoptions", data, { headers: { 'Authorization': 'Bearer '+token } })
    }

    show(id,token){
        return web.get(`/api/classesoptions/${id}/show`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    update(data,token){
        return web.put("/api/classesoptions/update", data,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    delete(id,token){
        return web.delete(`/api/classesoptions/${id}/delete`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    getOptionByClasse(id,token){
        return web.get(`/api/classesoptions/classe/${id}`,{ headers: { 'Authorization': 'Bearer '+token } })
    }
    getMontant(id,token){
        return web.get(`/api/classesoptions/getmontant/${id}`,{ headers: { 'Authorization': 'Bearer '+token } })
    }
}

export default new ClassesoptionsService()